import { VFC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Divider, ListItem, ListItemText } from '@material-ui/core';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { IconButton } from '@mui/material';
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircle from '@material-ui/icons/AddCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import { RootState } from '../../reducks/store/store';
import { ProductInCart } from '../../reducks/users/types';
// import NoImage from '../../../public/img/no_image.png';
import { getProductsInCart } from '../../reducks/users/selectors';
import {
  addProductToCart, removeProductFromCart, subtractProductFromCart
} from '../../reducks/users/operations';
import { FirebaseTimestamp } from '../../firebase';

type Props = {
  product: ProductInCart;
};
const useStyles = makeStyles({
  list: {
    height: 128,
  },
  image: {
    objectFit: 'cover',
    margin: 16,
    height: 96,
    width: 96,
  },
  text: {
    width: '100%',
  },
  inputField: {
    margin: '0 auto',
  },
  quantity:{
    width: '100%',
    textAlign: 'center',
  },
  quantityText: {
    width: '50px',
  },
});

export const CartListItem: VFC<Props> = (props) => {
  const { product } = props;
  const classes = useStyles();
  const selector = useSelector((state: RootState) => state);
  // 商品画像
  const image = product.images.length > 0 ? product.images[0].path : '/img/no_image.png';
  // 商品名
  const name = product.name;
  // 商品価格
  const price = product.price.toLocaleString();
  
  //reduxからcartを取得
  const carts = getProductsInCart(selector);

  const quantity = carts.find((productInCart) => productInCart.id === product.id)?.quantity ?? 0;


  const receiveDateParts = selector.global.receiveDate ?? new Date();
  const year = receiveDateParts.getFullYear();
  const month = ("00" + (receiveDateParts.getMonth() + 1)).slice(-2);
  const day = ("00" + receiveDateParts.getDate()).slice(-2);
  const yyyymmdd = Number(year + month + day);
  
  // 商品の合計金額
  const total = product.price * quantity;

  const dispatch = useDispatch();
 
  const addProductQuantity = async () => {
    const timestamp = FirebaseTimestamp.now();

    if(!product.stocks[yyyymmdd])return;

    if(!product.ordered || !product.ordered[yyyymmdd]){
      if(product.stocks[yyyymmdd] - quantity <= 0) return;
    }else{
        if(product.stocks[yyyymmdd] - product.ordered[yyyymmdd] - quantity <= 0) return;
    }
    dispatch(
      addProductToCart(
        {
          ...product,
          added_at: timestamp,
        },
        carts
      )
    );
  };

  const subtractProductQuantity = async () => {
    const timestamp = FirebaseTimestamp.now();

    if(quantity > 1){
      dispatch(
        subtractProductFromCart(
          {
            ...product,
            added_at: timestamp,
          },
          carts
        )
      );
    }
  };
  const removeProduct = async () => {
    const timestamp = FirebaseTimestamp.now();

    dispatch(
      removeProductFromCart(
        {
          ...product,
          added_at: timestamp,
        },
        carts
      )
    );
  };

  return (
    <>
      <ListItem className={classes.list}>
        <ListItemAvatar>
            <img className={classes.image} src={image} alt='商品画像' />
        </ListItemAvatar>
        <div className={classes.text}>
          <ListItemText primary={name} />
          <ListItemText primary={`¥${price} × ${quantity} = ¥${total.toLocaleString()}`} />
        </div>
      </ListItem>

      
      <div className={classes.quantity}>
        <ListItem>
          <IconButton onClick={() => subtractProductQuantity()}>
            <RemoveCircle />
          </IconButton>
          <div className={classes.quantityText}>
          <ListItemText
            primary={`個数 ${quantity}`}
          />
          </div>
          <IconButton onClick={() => addProductQuantity()}>
            <AddCircle />
          </IconButton>
          <IconButton onClick={() => removeProduct()}>
            <DeleteIcon />
          </IconButton>
        </ListItem>
      </div>
      <Divider />
    </>
  );
};
